class Home {
  constructor() {
      // this.lastScrollTop = 0;
      // tabs tabs-boxed
  }

  init() {

    // console.log('Home init');

    // let homeSupportCTAs = $('#home-support-ctas');
    // if(homeSupportCTAs.length) {
    //   let homeSupportCTAs_slides = homeSupportCTAs.find('.swiper-slide');
    //   if(homeSupportCTAs_slides.length > 3) {
    //     //create pagination
    //     homeSupportCTAs.append('<div class="swiper-pagination"></div>');
    //     let gallerySwiper = new Swiper(homeSupportCTAs.get(0), {
    //       slidesPerView: 'auto',
    //       autoHeight: true,
    //       // slidesPerColumn: 2,
    //       spaceBetween: 20,
    //       // slidesPerGroup: 2,
    //       watchOverflow: true,
    //       // spaceBetween: -5,
    //       // loop: true,
    //       // loopFillGroupWithBlank: true,
    //       breakpoints: {
    //         768: {
    //           spaceBetween: 24
    //         },
    //         1280: {
    //           spaceBetween: 30
    //         },
    //       //   // 1024: {
    //       //   //   spaceBetween: -10,
    //       //   // },
    //       //   // 1280: {
    //       //   //   spaceBetween: -20,
    //       //   // },
    //       },
    //       pagination: {
    //         el: '.swiper-pagination',
    //         type: 'bullets',
    //         clickable: true
    //       },
    //       on: {
    //         // 'resize': function () {
    //         //   this.changeDirection(_self.getDirection());
    //         // },
    //         'lock': function(){
    //           // console.log('lock event', this.el);
    //           $(this.el).addClass('swiper-pagination-locked');
    //         },
    //         'unlock': function(){
    //           // console.log('unlock event', this.el);
    //           $(this.el).removeClass('swiper-pagination-locked');
    //         },
    //       },
    //
    //     });
    //   }
    //
    // }

    let homePartners = $('#home-partenaires');
    // console.log('homePartners?', homePartners);
    if(homePartners.length) {
      let homePartners_slides = homePartners.find('.swiper-slide');
      // console.log('homePartners_slides', homePartners_slides);
      if(homePartners_slides.length > 1) {
        //create pagination
        homePartners.append('<div class="swiper-pagination"></div>');
        var galleryLogos = new Swiper(homePartners.get(0), {
          slidesPerView: 'auto',
          centeredSildes: true,
          slideToClickedSlide: true,
          threshold: 30,
          grid: {
            rows: 1,
            fill: 'row'
          },
          spaceBetween: 16,
          breakpoints: {
            768: {
              grid: {
                rows: 1,
              },
              slidesPerGroup: 3
            //   spaceBetween: 24
            },
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          on: {
            // 'resize': function () {
            //   this.changeDirection(_self.getDirection());
            // },
            'lock': function(){
              // console.log('lock event', this.el);
              $(this.el).addClass('swiper-pagination-locked');
            },
            'unlock': function(){
              // console.log('unlock event', this.el);
              $(this.el).removeClass('swiper-pagination-locked');
            },
          },

        });
      }

    }

    let homeTestimonials = $('#home-testimonials');
    // console.log('homeTestimonials?', homeTestimonials);
    if(homeTestimonials.length) {
      let homeTestimonials_slides = homeTestimonials.find('.swiper-slide');
      // console.log('homeTestimonials_slides', homeTestimonials_slides);
      if(homeTestimonials_slides.length > 1) {
        //create pagination
        homeTestimonials.prepend('<div class="swiper-pagination"></div>');
        let gallerySwiper = new Swiper(homeTestimonials.get(0), {
          slidesPerView: 1,
          spaceBetween: 20,
          autoHeight: true,
          autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          on: {
            // 'resize': function () {
            //   this.changeDirection(_self.getDirection());
            // },
            'lock': function(){
              // console.log('lock event', this.el);
              $(this.el).addClass('swiper-pagination-locked');
            },
            'unlock': function(){
              // console.log('unlock event', this.el);
              $(this.el).removeClass('swiper-pagination-locked');
            },
          },
          thumbs: {
            swiper: galleryLogos,
          },

        });
      }

    }


  }
}

export { Home };
